import { render, staticRenderFns } from "./Divisi.vue?vue&type=template&id=b83d54d0&scoped=true&"
import script from "./Divisi.vue?vue&type=script&lang=js&"
export * from "./Divisi.vue?vue&type=script&lang=js&"
import style0 from "./Divisi.vue?vue&type=style&index=0&id=b83d54d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83d54d0",
  null
  
)

export default component.exports